import { createSlice } from "@reduxjs/toolkit";
import { sharedInitialState, sharedReducers } from "./shared";

export type { GlobalState } from "./shared";

export const saleSummarySlice = createSlice({
  name: "saleSummary",
  initialState: sharedInitialState,
  reducers: {
    ...sharedReducers,
    // Web only — mobile has no equivalent. Replaces the whole slice state with the payload;
    // dispatched from components/RedirectPage with `reducerData.saleSummary`.
    updateSaleSummarySlice: (state, action) => {
      return action.payload;
    }
  },
});

export const {
  getSaleSummaryReportApi,
  updateSaleSummarySlice
} = saleSummarySlice.actions;

export default saleSummarySlice.reducer;
